import React, { useEffect } from 'react'
import memberDetailService from "@services/memberDetails.service";
import { notification } from "antd";
import ReminderWithNoNotification from "@assets/ReminderWithNoNotification.svg";
import './reminder-notification.scss'
import Icon from '@assets/icon_config'
import {accessConfig} from "@utils/constants";
import storage from "@services/storage.service";

export const ReminderNotifications: React.FC = ({ children }) => {
  const fetchReminderNotifications = () => {
    memberDetailService.fetchReminderNotifications().subscribe({
      next: (response: any) => {
        let reminders = response?.data?.data
        let timeDiff = response?.data?.time_diff

        if (reminders && reminders.length > 0) {
          notification.info({
            message: 'Reminders',
            description: `There are ${reminders.length} reminder(s) in another ${timeDiff} minutes.`,
            placement: 'bottomRight',
            onClick: () => {},
            className: 'reminder-notification',
            icon: <Icon name='reminder' colorOfBrand={'white'} />,
          });
        }
      },
      error: (e) => {
        console.log(e);
      },
    });
  }
  
  useEffect(() => {
    console.log("ReminderNotifications.useEffect1");
    const client = JSON.parse(localStorage.getItem("_client") || "{}");
    const token = storage.get("_token");
    const refreshToken = storage.get("_refreshToken");

    if (accessConfig["ReminderNotification"].includes(client.clientName) && token && refreshToken) {
      const interval = setInterval(() => {
        fetchReminderNotifications();
      }, 60 * 5000);
      fetchReminderNotifications();

      return () => {
        clearInterval(interval);
      };
    }
  }, []);

  return (
    <>
      {children}
    </>
  )
}
